import urls from "../utils/urls"
import { get,post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    page:1
   
    
}

const mutations={
   
    addGoods(state,value){

        post(urls.admin.goods.add,value).then((result)=>{
          
        
            state.result=result
          
         
          
         
             
          });
    },
    getGoodsDataIndex(state,val){
        
        
     
        post(urls.admin.goods.index,val).then((result)=>{
          
          
          
          state.result=result
       
       
        
       
           
        });
        
    },
    editGoods(state,value){

        if(value.type=="get"){
          
            get(urls.admin.goods.edit,value).then((result)=>{
          
        
                state.result=result
              
             
              
             
                 
              });
        }else{


            post(urls.admin.goods.edit,value).then((result)=>{
          
        
                state.result=result
              
             
              
             
                 
              });
        }
        
    },
    deleteGoods(state,value){

        post(urls.admin.goods.delete,value).then((result)=>{
          
        
            state.result=result
          
         
          
         
             
          });

    },
    updownGoods(state,value){

        post(urls.admin.goods.updown,value).then((result)=>{


            state.result=result





        });

    },
   
   
}
const  actions={
    getGoodsDataIndexAction(context,value){
       
        context.commit("getGoodsDataIndex",value)
       
    },
    addGoodsAction(context,value){
       
        
        context.commit("addGoods",value)
       
    },
   
    editGoodsAction(context,value){
       
        
        context.commit("editGoods",value)
       
    },
    deleteGoodsAction(context,value){
       
        
        context.commit("deleteGoods",value)
       
    },
    updownGoodsAction(context,value){


        context.commit("updownGoods",value)

    },

  
    
   

}

export default {state,mutations,actions}